import { render, staticRenderFns } from "./InputSuggestions.vue?vue&type=template&id=8eb25dee&scoped=true&"
import script from "./InputSuggestions.vue?vue&type=script&lang=js&"
export * from "./InputSuggestions.vue?vue&type=script&lang=js&"
import style0 from "./InputSuggestions.vue?vue&type=style&index=0&id=8eb25dee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8eb25dee",
  null
  
)

export default component.exports